type Props = {
  tokenName: string;
  className?: string;
};
export const UnknownTokenLogo = ({ tokenName, className }: Props) => {
  return (
    <div
      className={`w-5 h-5 rounded-full bg-background_primary shadow flex items-center justify-center text-black ${className}`}
    >
      {tokenName.substring(0, 1)}
    </div>
  );
};
